import { CssPropertyType } from "@wix/ambassador-devcenter-v1-component-type-data/types";
export const StyleType = Object.fromEntries(Object.entries(CssPropertyType).filter(_ref => {
  let [key] = _ref;
  return key !== "B";
}));
//# sourceMappingURL=metadata.js.map